import React from 'react';
import { FieldValues } from '../../types';
import Error from '../Error';
import styles from './Attachments.module.scss';

interface FileProps {
  file: FieldValues['files'][number];
  error?: string;
  onRemove: (file: FieldValues['files'][number]) => void;
}

const File = ({ file, error, onRemove }: FileProps): React.ReactElement => {
  return (
    <div className={styles.attachmentsFile}>
      <div className={styles.attachmentsFileName}>
        <div>{file.name}</div>
        {error ? <Error error={error} /> : null}
      </div>
      <div className={styles.attachmentsFileRemove} onClick={() => onRemove(file)}>
        Remove
      </div>
    </div>
  );
};

export default File;
